<pershing-responsive [respondToWindow]="true" [small]="smallRef" [medium]="smallRef"
  [large]="largeRef"></pershing-responsive>
<ng-template #largeRef>
  <ng-container *ngTemplateOutlet="
      search;
      context: { className: 'qq-container_input-quote-large' }
    "></ng-container>
</ng-template>
<ng-template #smallRef>
  <ng-container *ngTemplateOutlet="
      search;
      context: { className: 'qq-container_input-quote-small' }
    "></ng-container>
</ng-template>
<ng-template #search let-className="className">
  <mat-form-field appearance="outline" [ngClass]="className" (keydown.esc)="onClose()" id="quick-quote-search">
    <mat-icon matPrefix><i class="fa fa-search center"></i></mat-icon>
    <input type="text" [matAutocomplete]="auto" [placeholder]="'MODERN_QUICK_QUOTE_PLACEHOLDER' | translate"
      [attr.aria-label]="'MODERN_QUICK_QUOTE_ADA_LABEL' | translate" matInput
      oninput="this.value = this.value.toUpperCase()" [formControl]="formControl" />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="openQuoteDialog($event.option.value)"
      [autoActiveFirstOption]="!isLoading">
      <ng-container *ngIf="isLoading">
        <mat-option [disabled]="true">
          <mat-spinner [diameter]="30"></mat-spinner>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="!isLoading && filteredSymbols.length > 0">
        <mat-option *ngFor="let symbols of filteredSymbols" [value]="symbols.Symbol">
          <strong>{{ symbols.Symbol }}</strong>
          <span> {{ symbols.Name }}</span>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
    <mat-icon matSuffix (click)="onClose()"><i class="fas fa-times center"></i></mat-icon>
  </mat-form-field>
</ng-template>